import { render } from "./Services6Section.vue?vue&type=template&id=37adb4ac&scoped=true"
import script from "./Services6Section.vue?vue&type=script&lang=js"
export * from "./Services6Section.vue?vue&type=script&lang=js"

import "./Services6Section.vue?vue&type=style&index=0&id=37adb4ac&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-37adb4ac"]])

export default __exports__